<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>We acknowledge and thank the assistance provided by June Abbott who attended the interviews that form the basis of this book with us and afterwards checked the translations of the transcripts. Her professional linguistic skills were a great help.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?57cb0c88